import { Checkbox, FormControlLabel } from "@mui/material";
import React from "react";

const LabelledCheckbox = ({ label, sx, ...checkboxProps }) => (
  <FormControlLabel
    label={label}
    labelPlacement={"start"}
    control={<Checkbox color={"primary"} {...checkboxProps} />}
    sx={[
      {
        border: 1,
        borderColor: "divider",
        borderRadius: 1,
        pl: 1.5,
        mx: 0,
        width: "fit-content",
        flexShrink: 0,
      },
      ...(Array.isArray(sx) ? sx : [sx]),
    ]}
  />
);

export default LabelledCheckbox;
